import { ActivityPreferencesDef, ServiceRequirement } from "./definitions";

function OwnArrangement() {
  return (
    <span className="text-xs border-purple-500 border-2 rounded-md px-1 text-purple-500 font-bold self-center">
      Own Arrangement
    </span>
  );
}

type QuotationActivityProps = {
  activity: ServiceRequirement;
  index: number;
  excludedServiceUids: Set<string>;
  excludeSrv: (uid: string) => void;
  includeSrv: (uid: string) => void;
};

export function QuotationActivity({
  activity,
  index,
  excludedServiceUids,
  excludeSrv,
  includeSrv,
}: QuotationActivityProps) {
  const preferences = activity.preferences as ActivityPreferencesDef;
  const poiLabel = preferences?.poi?.label;

  return (
    <div
      key={`${index}-${activity.service_date}`}
      className="QuotationActivity px-2 inline-grid gap-2 grid-cols-[max-content_1fr_max-content_max-content] bg-green-100 rounded-md p-1 items-start"
    >
      <strong>
        {index + 1}. {!!poiLabel ? `${poiLabel} - ` : ""}
      </strong>
      <span>{activity.notes}</span>
      {preferences.client_own_arrangement ? <OwnArrangement /> : <div />}
      <input
        type="checkbox"
        checked={!excludedServiceUids.has(activity.uid)}
        className="self-center"
        onChange={(e) => {
          if (e.target.checked) {
            includeSrv(activity.uid);
          } else {
            excludeSrv(activity.uid);
          }
        }}
      />
    </div>
  );
}
